import { render, staticRenderFns } from "./PaymentPlanReview.vue?vue&type=template&id=5fa1cc11&scoped=true"
import script from "./PaymentPlanReview.vue?vue&type=script&lang=js"
export * from "./PaymentPlanReview.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlanReview.vue?vue&type=style&index=0&id=5fa1cc11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1cc11",
  null
  
)

export default component.exports